import PieChart from './PieChart';
import type { StyleConfig } from '../../../../types/bi';
import type { DrilldownEvent } from '../../utils/drilldown';

interface DonutChartProps {
  data: { columns: string[]; rows: Record<string, unknown>[] };
  dimensions: string[];
  measures: { alias: string }[];
  style?: StyleConfig;
  onDrillDown?: (event: DrilldownEvent) => void;
}

export default function DonutChart(props: DonutChartProps) {
  return <PieChart {...props} donut />;
}
